"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const AriaContext_1 = require("src/ts/contexts/AriaContext");
// AriaLive need to re-render when its context is being updated. This does not make it candidate for PureComponent
class AriaLive extends React.Component {
    render() {
        // ariaLive refs should stay unchanged for the lifecycle of the application
        // It means that conditional rendering of div[role=region] won't work, but its content will
        return React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement(React.Fragment, null,
            React.createElement("div", { key: 'assertive', role: 'region', className: 'ariaLive', "aria-live": 'assertive' }, ariaContext.message.assertive && ariaContext.message.text),
            React.createElement("div", { key: 'polite', role: 'region', className: 'ariaLive', "aria-live": 'polite' }, !ariaContext.message.assertive && ariaContext.message.text)));
    }
}
exports.AriaLive = AriaLive;
